import {
  GET_TRIBUN_COUPON_DETAILS_REQUEST,
  GET_TRIBUN_COUPON_DETAILS_SUCCESS,
  GET_TRIBUN_COUPON_DETAILS_FAILURE,
  RESET_TRIBUN_COUPON_DETAILS,
  SAVE_UNEVALUATED_EVENTS,
  RESET_UNEVALUATED_EVENTS,
  LIKE_OR_UNLIKE_COUPON_REQUEST,
  LIKE_OR_UNLIKE_COUPON_SUCCESS,
  LIKE_OR_UNLIKE_COUPON_FAILURE,
  FOLLOW_TRIBUN_USER_REQUEST,
  FOLLOW_TRIBUN_USER_SUCCESS,
  FOLLOW_TRIBUN_USER_FAILURE,

  SEND_COMMENT_REQUEST,
  SEND_COMMENT_SUCCESS,
  SEND_COMMENT_FAILURE,

  DELETE_COMMENT_REQUEST,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_FAILURE,

  COMMENT_FORBID_ALLOW_REQUEST,
  COMMENT_FORBID_ALLOW_SUCCESS,
  COMMENT_FORBID_ALLOW_FAILURE,

  SHOW_OR_HIDE_COUOPON_REQUEST,
  SHOW_OR_HIDE_COUOPON_SUCCESS,

  UPDATE_TRIBUN_COUPON_NAME_REQUEST,
  UPDATE_TRIBUN_COUPON_NAME_SUCCESS,
  UPDATE_TRIBUN_COUPON_NAME_FAILURE,

  DELETE_TRIBUN_COUPON_NAME_REQUEST,
  DELETE_TRIBUN_COUPON_NAME_SUCCESS,
  DELETE_TRIBUN_COUPON_NAME_FAILURE
} from 'Store/constants';


const initialState = {
  data: null,
  isLoading: null,
  error: null,
  storedFeeds: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TRIBUN_COUPON_DETAILS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_TRIBUN_COUPON_DETAILS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_TRIBUN_COUPON_DETAILS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case SAVE_UNEVALUATED_EVENTS:
    {
      const { feedId, unevaluatedEvents } = action.payload;

      if (unevaluatedEvents === null) {
        const storedFeedsCopy = { ...state.storedFeeds };
        delete storedFeedsCopy[feedId];
    
        return {
          ...state,
          storedFeeds: storedFeedsCopy
        };
      }

      return {
        ...state,
        storedFeeds: {
          ...state.storedFeeds,
          [feedId]: unevaluatedEvents
        }
      };
    }
    case RESET_UNEVALUATED_EVENTS:
      return {
        ...state,
        storedFeeds: {}
      };
    case RESET_TRIBUN_COUPON_DETAILS:
      return { ...initialState };

    case FOLLOW_TRIBUN_USER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FOLLOW_TRIBUN_USER_SUCCESS:
    {
      if (action.tabType === 'coupon-detail') {
        state.data.user.stats.followers = action.payload.followerCount;
        state.data.user.following = !state.data.user.following;
      }

      return { ...state, isLoading: false, error: null };
    }
    case FOLLOW_TRIBUN_USER_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case LIKE_OR_UNLIKE_COUPON_REQUEST:
      return { ...state, isLoading: true, error: null };
    case LIKE_OR_UNLIKE_COUPON_SUCCESS:
    {
      if (action.tabType === 'coupon-detail') {
        if (state.data.feedId === action.feedId) {

          state.data.likes = state.data.liked ? state.data.likes - 1 : state.data.likes + 1;
          state.data.liked = !state.data.liked;
        }
      }
      return { ...state, isLoading: false, error: null };
    }
    case LIKE_OR_UNLIKE_COUPON_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case SEND_COMMENT_REQUEST:
      return { ...state, isLoading: true, error: null };

    case SEND_COMMENT_SUCCESS:
      if (action.tabType === 'coupon-detail') {
        state.data.comments += 1;
      }
      return { ...state, isLoading: false, error: null };

    case SEND_COMMENT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case DELETE_COMMENT_REQUEST:
      return { ...state, isLoading: true, error: null };

    case DELETE_COMMENT_SUCCESS:
      if (action.tabType === 'coupon-detail') {
        state.data.comments -= 1;
      }
      return { ...state, isLoading: false, error: null };

    case DELETE_COMMENT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case COMMENT_FORBID_ALLOW_REQUEST:
      return { ...state, isLoading: true, error: null };

    case COMMENT_FORBID_ALLOW_SUCCESS:
      if (action.tabType === 'coupon-detail') {
        state.data.commentForbidden = !state.data.commentForbidden;
      }
      return { ...state, isLoading: false, error: null };

    case COMMENT_FORBID_ALLOW_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case SHOW_OR_HIDE_COUOPON_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SHOW_OR_HIDE_COUOPON_SUCCESS:
    {
      if (action.tabType === 'coupon-detail') {
        if (state.data.feedId === action.feedId) {
          state.data.hidden = !state.data.hidden;
        }
      }
      return { ...state, isLoading: false, error: null };
    }
    case UPDATE_TRIBUN_COUPON_NAME_REQUEST:
      return { ...state, isLoading: true, error: null };
    case UPDATE_TRIBUN_COUPON_NAME_SUCCESS:
      if (action.tabType === 'coupon-detail') {
        state.data.description = action.description;
      }
      return { ...state, isLoading: false, error: null };
    case UPDATE_TRIBUN_COUPON_NAME_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case DELETE_TRIBUN_COUPON_NAME_REQUEST:
      return { ...state, isLoading: true, error: null };
    case DELETE_TRIBUN_COUPON_NAME_SUCCESS:
      if (action.tabType === 'coupon-detail') {
        state.data.description = null;
      }
      return { ...state, isLoading: false, error: null };
    case DELETE_TRIBUN_COUPON_NAME_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};

